
import {Pipe, PipeTransform} from '@angular/core';

/**
 * Pipe to filter tags in the table of contents search box
 */
@Pipe({
  name: 'tagFilterBy',
  pure: true
})
export class TagFilterByPipe implements PipeTransform {
  /**
   * Searchs through an array of tags for anything resembling the user input
   *
   * @param items: tag array
   * @param searchText: user search parameters
   */
  transform(items: any[], searchText: string): any[] {
    if (!items) { return []; }
    if (!searchText) { return items; }
    searchText = searchText.toLowerCase();
    return items.filter( it => it.toLowerCase().includes(searchText));
  }
}